// extracted by mini-css-extract-plugin
export var typingIndicator = "_qj-0";